
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './../IAppForm'
import { ApplicationModule } from '@/store'

import AddressDto from '@/types/dto/addressDto'
import CFInput from '../../inputs/CFInput'

	@Component({
	  name: 'AddressLength'
	})
export default class AddressLength extends Vue implements IAppForm {
  // #region Props

		@Prop() address!: AddressDto;
		@Prop() addressIndex!: number;
		@Prop({ default: false }) editing!: boolean;
		@Prop({ default: false }) isNew!: boolean;

		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		monthCount = 0;
		years: number | null = null;
		months: number | null = null;

		isValid = true;
		showMonthError = false;
		showYearError = false;
		showError = false;

		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit')
		}

		previous () {
		  this.$emit('previous')
		}

		validate () {
		  this.showMonthError = !(this.$refs.monthsAtAddress as unknown as CFInput).validate()
		  this.showYearError = !(this.$refs.yearsAtAddress as unknown as CFInput).validate()
		  this.showError = this.showMonthError || this.showYearError

		  if (this.showError) {
		    return false
		  }

		  return true
		}

		validateMonth () {
		  this.showMonthError = false
		  this.showError = false

		  if ((this.address.yearsAtAddress <= 0) && (this.address.monthsAtAddress <= 0)) {
		    this.showError = true
		    this.showMonthError = true
		    return false
		  }

		  this.address.monthsAtAddress = this.address.monthsAtAddress < 0 ? 0 : this.address.monthsAtAddress > 12 ? 12 : parseInt(this.address.monthsAtAddress.toString())

		  this.showMonthError = false
		  this.showYearError = false

		  return true
		}

		validateYear () {
		  this.showYearError = false
		  this.validateMonth()

		  this.address.yearsAtAddress = this.address.yearsAtAddress < 0 ? 0 : this.address.yearsAtAddress

		  return true
		}

		input () {
		  this.showError = false
		}

		setMonthCount () {
		  let count = 0

		  this.value.addresses.forEach(a => {
		    count += Number(a.yearsAtAddress * 12)
		    count += Number(a.monthsAtAddress)
		  })

		  this.monthCount = count
		}

		clearErrors () {
		  this.showError = false
		  this.showMonthError = false
		  this.showYearError = false
		}

		// #endregion

		// #region Computed

		get hasErrors () {
		  return this.showMonthError || this.showYearError
		}

		get editingAddressIndex () {
		  return ApplicationModule.editingAddressIndex
		}

		get cssClass () {
		  return this.hasErrors ? 'error' : ''
		}

		// #endregion

		// #region Watches

		@Watch('editingAddressIndex')
		changeEmployment () {
		  this.clear()
		}

		@Watch('address', { deep: true })
		clear () {
		  this.clearErrors()

		  if (this.address.yearsAtAddress > 0) {
		    this.years = this.address.yearsAtAddress
		  } else {
		    this.years = null
		  }
		  if (this.address.monthsAtAddress > 0) {
		    this.months = this.address.monthsAtAddress
		  } else {
		    this.months = null
		  }
		}

		@Watch('years')
		updateYears () {
		  setTimeout(() => {
		    this.validate()

		    if (this.years) {
		      this.address.yearsAtAddress = this.years
		    } else {
		      this.address.yearsAtAddress = 0
		    }
		  }, 1)
		}

		@Watch('months')
		updateMonths () {
		  setTimeout(() => {
		    this.validate()

		    if (this.months) {
		      this.address.monthsAtAddress = this.months
		    } else {
		      this.address.monthsAtAddress = 0
		    }
		  }, 1)
		}

  // #endregion
}
